import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import DashboardAppBar from "../../../Components/Navbar/AppBar";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Home from "./Home";
import Analytics from "./Analytics";
import Profile from "./Profile";
import Settings from "./Settings";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import Diversity1Icon from "@mui/icons-material/Diversity1";
import Products from "./Products";
import Employees from "./Employees";
import SettingsIcon from "@mui/icons-material/Settings";
import ChatIcon from "@mui/icons-material/Chat";
import ArticleIcon from "@mui/icons-material/Article";
import ChangeCircleIcon from "@mui/icons-material/ChangeCircle";
import { ListItemIcon } from "@mui/material";
import FeedbackData from "./FeedbackData";
import ContactsData from "./ContactsData";
import AppointmentData from "./AppointmentData";
import BookmarkAddedIcon from "@mui/icons-material/BookmarkAdded";
import RequestData from "./RequestData";
import PatientsData from "./PatientsData";
import StorageIcon from "@mui/icons-material/Storage";
import ProjectsData from "./ProjectsData";
import BookingData from "./BookingData";

const drawerWidth = 220;

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
  })
);

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

export default function DashboardRouting1() {
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [themeMode, setThemeMode] = React.useState("dark");
  const [name, setName] = React.useState([]);
  const [names, setNames] = React.useState([]);
  const navigate = useNavigate();

  const darkTheme = createTheme({
    palette: {
      mode: themeMode,
    },
  });

  const toggleThemeMode = () => {
    setThemeMode(themeMode === "light" ? "dark" : "light");
  };

  const color = darkTheme.palette.mode === "dark" ? "#121212" : "#F5F5F5";
  const Iconcolor = "#2596be";

  let res = {
    data: Array(),
    data: [
      {
        name: "Dashboard",
        url: "home",
        icon: <HomeRoundedIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <Home />,
      },
      {
        name: "Analytics",
        url: "analytics",
        icon: <InsertChartIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <Analytics />,
      },
      {
        name: "Projects Data",
        url: "projects-data",
        icon: <PeopleAltIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <ProjectsData />,
      },
      {
        name: "Patients Data",
        url: "patients-data",
        icon: <StorageIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <PatientsData />,
      },
      {
        name: "Request Data",
        url: "request-data",
        icon: <ChangeCircleIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <RequestData />,
      },
      {
        name: "Bookings",
        url: "booking-data",
        icon: <BookmarkAddedIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <BookingData />,
      },
      {
        name: "Contact",
        url: "contact-data",
        icon: <ArticleIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <ContactsData />,
      },
      {
        name: "Feedback",
        url: "feedback-data",
        icon: <Diversity1Icon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <FeedbackData />,
      },
    ],
  };

  let reses = {
    data: Array(),
    data: [
      {
        name: "Settings",
        url: "settings",
        icon: <SettingsIcon sx={{ fontSize: 29, color: Iconcolor }} />,
        element: <Settings />,
      },
    ],
  };

  // const handleDrawerClose = () => {
  //   setOpen(false);
  // };

  const showSidebar = () => setOpen(!open);

  useEffect(() => {
    setName(res.data);
    setNames(reses.data);
  }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <Box sx={{ display: "flex" }} bgcolor={color}>
        <CssBaseline />
        <DashboardAppBar onClick={showSidebar} onClose={toggleThemeMode} />
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box",
            },
          }}
          variant="persistent"
          anchor="left"
          open={open}
        >
          <DrawerHeader>
            <IconButton></IconButton>
          </DrawerHeader>
          <List>
            {name.map((text, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(text.url);
                  }}
                >
                  <ListItemIcon>{text.icon}</ListItemIcon>
                  <ListItemText>{text.name}</ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <List>
            {names.map((text, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton
                  onClick={() => {
                    navigate(text.url);
                  }}
                >
                  <ListItemIcon>{text.icon}</ListItemIcon>
                  <ListItemText>{text.name}</ListItemText>
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </Drawer>
        <Main open={open}>
          <DrawerHeader />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="projects-data" element={<ProjectsData />} />
            <Route path="patients-data" element={<PatientsData />} />
            <Route path="booking-data" element={<BookingData />} />
            <Route path="request-data" element={<RequestData />} />
            <Route path="feedback-data" element={<FeedbackData />} />
            <Route path="contact-data" element={<ContactsData />} />
            <Route path="settings" element={<Settings />} />
          </Routes>
        </Main>
      </Box>
    </ThemeProvider>
  );
}
